// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromLarge":"(min-width: 960px)","loadingOverlay":"Gd3b3cd","loading":"G97fc49","header":"G0a6524 Gb0a9a6 G326357"};